import React from "react";

import UseTemplateCTA from "@sharedComponents/content-links/use-template-cta";
import PreviewTemplateCTA from "@sharedComponents/content-links/preview-template-cta";
import SelectItemsCta from "@sharedComponents/content-links/select-items";

import { isEshopStore } from "@helpers/shop";

import { MOMENTS } from "@constants/routes";

const ContentLinks = ({
  useTemplateCtaClassName = "",
  previewTemplateCtaClassName = "",
  type = "",
  feUrl = "",
  pageName = "",
  storeName = "",
  storeNumber = "",
  onTemplateSelect = () => {},
}) => {
  return pageName === MOMENTS ? (
    !isEshopStore(type) && (
      <SelectItemsCta
        className={useTemplateCtaClassName}
        pageName={pageName}
        feUrl={feUrl}
        storeName={storeName}
        storeNumber={storeNumber}
      />
    )
  ) : (
    <>
      {!isEshopStore(type) && (
        <UseTemplateCTA
          className={useTemplateCtaClassName}
          pageName={pageName}
          storeName={storeName}
          storeNumber={storeNumber}
          onTemplateSelect={onTemplateSelect}
        />
      )}
      <PreviewTemplateCTA
        className={previewTemplateCtaClassName}
        pageName={pageName}
        feUrl={feUrl}
        storeName={storeName}
        storeNumber={storeNumber}
      />
    </>
  );
};

export default ContentLinks;
